export const specialExpressionTypes = {
  '??': 0,
  '&&': 1,
  '||': 2,
  'array': 3,
  'cond': 4,
  'defined?': 5,
  'block': 6,
  'doseq': 7,
  '0_lambda': 8,
  'for': 9,
  'if': 10,
  'let': 11,
  'loop': 12,
  'object': 13,
  'recur': 14,
  'match': 15,
  'throw': 16,
  'try': 17,
  'unless': 18,
  'import': 19,
} as const
